var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DateTime } from "luxon";
import { useDrop } from "react-dnd";
import clsx from "clsx";
import { EventItemType } from "./constants";
var EVENT_VIEW_STYLES = "px-1 border-2 border-lochivar-default flex-shrink-0 flex relative m-0 p-0 pointer-events-auto flex-grow text-transparent";
var HOVER_STYLES = "border-opacity-100";
var MOUSE_OUT_STYLES = "border-opacity-0";
/**
 * Essentially an empty cell that serves as a drop target in a generated
 * grid that appears above a calendar. This component represents a date
 * and position.
 * @param {Object} props Properties for the react component.
 */
export var EventTargetView = function (_a) {
    var handleExpand = _a.onExpand, handleDrop = _a.onDrop, position = _a.position, date = _a.date, simplified = _a.simplified, partition = _a.partition, fontSizeOverride = _a.fontSizeOverride, externalFontSize = _a.fontSize, grow = _a.grow;
    var _b = useDrop(function () { return ({
        accept: [EventItemType.SEGMENT, EventItemType.START, EventItemType.END],
        collect: function (monitor) {
            return {
                isOver: monitor.isOver(),
                item: monitor.getItem(),
                type: monitor.getItemType(),
            };
        },
        drop: function (_, monitor) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = monitor.getItemType();
                        switch (_a) {
                            case EventItemType.SEGMENT: return [3 /*break*/, 1];
                            case EventItemType.START: return [3 /*break*/, 3];
                            case EventItemType.END: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, handleDrop(item.uuid, item.calendarId, date, position, partition)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, handleExpand(item.uuid, item.calendarId, DateTime.fromISO(date, { zone: "utc" })
                            .startOf("day")
                            .toISO({ includeOffset: false }), monitor.getItemType() === EventItemType.START)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); },
    }); }, [date, position, partition]), _c = _b[0], isOver = _c.isOver, item = _c.item, drop = _b[1];
    var fontSize = fontSizeOverride
        ? fontSizeOverride
        : simplified
            ? 4
            : simplified
                ? 8
                : externalFontSize;
    return (_jsx("div", __assign({ className: clsx(EVENT_VIEW_STYLES, isOver ? HOVER_STYLES : MOUSE_OUT_STYLES), style: {
            fontSize: fontSize,
            flexGrow: grow ? 1 : 0,
        }, ref: drop }, { children: "Test" }), void 0));
};
